export const violations = {
  "violations.getReportByDealer": "violations.getReportByDealer",
  "violations.getAllReport": "violations.getAllReport",
  "violations.getAll": "violations.getAll",
  "violations.getById": "violations.getById",
  "violations.getComments": "violations.getComments",
  "violations.create": "violations.create",
  "violations.dealerFix": "violations.dealerFix",
  "violations.giveResponseToDealer": "violations.giveResponseToDealer",
  "violations.addComment": "violations.addComment",
  "violations.edit": "violations.edit",
  "violations.delete": "violations.delete",
  "violations.reject": "violations.reject",
  "violations.unDelete": "violations.unDelete",
} as const;
